import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container, Spinner, Alert } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import CommonDataTable from '../../common/DataTable';
import { getCategoryColumns } from '../../Components/Common/columns/Category';
import { bulkDeleteCategory, deleteCategory, getCategoryWithPage } from '../../slices/thunks';
import { Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { setFilterParams } from '../../slices/category/reducer';

const CategoryList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { categories, loading, error, filterParams } = useSelector((state) => state.category || {});

  const [selectedRows, setSelectedRows] = useState([]);
  const [confirmOpenForId, setConfirmOpenForId] = useState();

  useEffect(() => {
    const params = filterParams || { currentPage: 1, perPage: 20 };
    dispatch(getCategoryWithPage(params));
  }, [dispatch, filterParams]);

  const handleDelete = useCallback(async (event, categoryId) => {
    event.preventDefault();
    try {
      await dispatch(deleteCategory({ id: categoryId }));
      dispatch(getCategoryWithPage(filterParams));
    } catch (error) {
      console.error('Error deleting category:', error);
    }
  }, [dispatch, filterParams]);

  const handleBulkDelete = useCallback(async () => {
    const categoryIds = selectedRows.map((row) => row.id);
    if (categoryIds.length > 0) {
      try {
        await dispatch(bulkDeleteCategory({ categoryIds }));
        dispatch(getCategoryWithPage(filterParams));
        setSelectedRows([]);
      } catch (error) {
        console.error('Error in bulk delete:', error);
      }
    }
  }, [dispatch, selectedRows, filterParams]);
  
  const handleAddButtonClick = () => {
    navigate('/category/add-form');
  };

  const fetchData = useCallback((newFilterParams) => {
    // Update filter params in Redux state
    dispatch(setFilterParams(newFilterParams));
    // Fetch new data with updated params
    dispatch(getCategoryWithPage(newFilterParams));
  }, [dispatch]);

  const columns = getCategoryColumns({
    onDeleteClick: handleDelete,
    confirmOpenForId,
    setConfirmOpenForId,
  });

  // Extract the nested data structure
  const categoryData = categories?.data?.data?.data || [];
  const totalCount = categories?.data?.data?.totalCount || 0;
  const currentPage = categories?.data?.data?.currentPage || 1;
// 
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Categories" pageTitle="Categories" />
        </Container>
      </div>
      <div className="table-container">
        {loading && (
          <div className="text-center">
            <Spinner color="primary" />
            <p>Loading categories...</p>
          </div>
        )}

        {error && (
          <Alert color="danger">
            <strong>Error:</strong> {error}
          </Alert>
        )}
        {!loading && !error && categoryData.length === 0 && (
          <div className="text-center my-4">
            <h4>No categories available</h4>
            <p>Click the Add button to create a new category</p>
          </div>
        )}

        {!loading && !error && (
          <CommonDataTable
            from="category"
            data={categoryData}
            totalRows={totalCount}
            loading={loading}
            showAddButton={true} 
            addOnClickMethod={handleAddButtonClick}
            columns={columns}
            checkboxEnabled={false}
            selectedRows={selectedRows}
            bulkSelected={(rows) => setSelectedRows(rows)}
            searchEnable={false}
            filterParams={{ ...filterParams, currentPage }}
            fetchData={fetchData}
            showExportButton={false}
            exportFileName="category"
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default CategoryList;
